import useSWR from 'swr';
import { Constants } from '@CONFIG';
import { axios } from '@LIBS';
import { useHistory } from 'react-router';

const CommonEndpoints = {};
const useOptions = (token) => {
  const history = useHistory();
  return useSWR(
    token ? `${Constants.BACKEND_API_URL}/api/options` : null,
    (url) =>
      axios({
        url,
        method: 'GET',
        redirectIfFailed: () => history.push('/auth/login'),
        hideErrorMessageFromServer: true,
        dataKey: 'data',
      })
  );
};

const ValidateAddress = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/address/validate`,
    method: 'POST',
    data: values,
  });

  return response;
};

export { useOptions, CommonEndpoints, ValidateAddress };
